/**
 * RBAC Permission Utilities
 *
 * Supported modules:
 *   ai_tools, analytics_dashboard, announcements, channel, communication_logs,
 *   competition, courses, event, impact_story, integrated_school_process,
 *   messages, notifications, pbl, podcast, polls, question_bank, quizzes,
 *   reports, roles, short_videos, teacher_lounge, teaching_resources, tlm,
 *   users, webinar
 *
 * Supported actions:
 *   create, delete, export, moderate, publish, read, send, unpublish, update, upload
 */

/**
 * Builds a Set of permission codenames from the user's roles array.
 * Example codename: "pbl:export", "courses:read"
 *
 * @param {object} userData - The result object from the currentUser API
 * @returns {Set<string>}
 */
export function buildPermissionSet(userData) {
  const permSet = new Set();
  if (!userData || !Array.isArray(userData.roles)) return permSet;

  userData.roles.forEach((role) => {
    if (Array.isArray(role.permissions)) {
      role.permissions.forEach((perm) => {
        if (perm.codename) {
          permSet.add(perm.codename);
        }
      });
    }
  });

  return permSet;
}

/**
 * Checks if a permission set contains a specific module + action.
 *
 * @param {Set<string>} permSet
 * @param {string} module - e.g. "pbl", "courses"
 * @param {string} action - e.g. "export", "create", "delete"
 * @returns {boolean}
 */
export function hasPermission(permSet, module, action) {
  if (!permSet || !module || !action) return false;
  return permSet.has(`${module}:${action}`);
}
